export default "/images/ebt24x24.svg?51a74252bcf464208a7298d04c0dfeb6";